import FormValidationStrategy from "../strategy/FormValidationStrategy.js";

export default class NameValidationStrategy extends FormValidationStrategy{
    validate(valueString, isRequired) {
        const value = valueString
            .toString()
            .trim(),
            minLength = 2
        ;

        let isValid = false;

        if (!value.length && isRequired) {
            return {
                isValid,
                message: this.loadErrorMessage("empty", "ФИО")
            }
        }

        if (value.length < minLength) {
            return {
                isValid,
                message: this.loadErrorMessage("minLength", minLength)
            }
        }

        isValid = true;

        return {
            isValid,
            message: ""
        }
    }
}
